import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { BILLING_CONFIG } from "./apiRoutes";

interface UseGetBillingStatProps {
  communityId: string;
  billingYear: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBillingStat = async (communityId: string, billingYear: string) =>
  await axiosAuth.get(
    `${BILLING_CONFIG(communityId)}/stats?billingYear=${billingYear}`
  );

const useGetBillingStat = ({
  communityId,
  billingYear,
  queryParams,
}: UseGetBillingStatProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["billing-stats", communityId, billingYear],
    queryFn: () => getBillingStat(communityId, billingYear),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetBillingStat;
